import { useCallback, useEffect, useState } from 'react';
import { Box, Button, FormControl, InputLabel, Select, MenuItem, Snackbar, Alert } from '@mui/material';
import { getApprovers, setConfig } from '../../api/systemConfigApi';
import { getAllAgents } from '../../api/userApi';

export default function ApproverConfig() {
  const [users, setUsers] = useState([]);
  const [approver1Id, setApprover1Id] = useState('');
  const [approver2Id, setApprover2Id] = useState('');
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const fetchData = useCallback(async () => {
    try {
      const [usersRes, approversRes] = await Promise.all([getAllAgents(), getApprovers()]);
      setUsers(usersRes.data);
      setApprover1Id(approversRes.data.approver1Id || '');
      setApprover2Id(approversRes.data.approver2Id || '');
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleSave = async () => {
    try {
      await setConfig('Approver1Id', approver1Id);
      await setConfig('Approver2Id', approver2Id);
      setSnackbar({ open: true, message: 'Approvers updated', severity: 'success' });
    } catch (e) { setSnackbar({ open: true, message: 'Failed to save', severity: 'error' }); }
  };

  const inputSx = { fontFamily: "'Poppins', sans-serif", fontSize: '0.85rem' };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <Box sx={{ mb: 2 }}>
        <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>Approver Configuration</h2>
        <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748B', fontFamily: "'Poppins', sans-serif" }}>Set who approves commission slips</p>
      </Box>
      <Box sx={{ backgroundColor: '#fff', borderRadius: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', p: 3, maxWidth: 500 }}>
        <FormControl size="small" fullWidth sx={{ mb: 2 }}>
          <InputLabel>Approver 1</InputLabel>
          <Select value={approver1Id} onChange={e => setApprover1Id(e.target.value)} label="Approver 1" sx={inputSx}>
            <MenuItem value="">— None —</MenuItem>
            {users.filter(u => u.status === 'Active').map(u => (
              <MenuItem key={u.userId} value={String(u.userId)}>{`${u.lastName ?? ''} ${u.firstName ?? ''}`.trim() || u.alias || ''}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth sx={{ mb: 3 }}>
          <InputLabel>Approver 2</InputLabel>
          <Select value={approver2Id} onChange={e => setApprover2Id(e.target.value)} label="Approver 2" sx={inputSx}>
            <MenuItem value="">— None —</MenuItem>
            {users.filter(u => u.status === 'Active').map(u => (
              <MenuItem key={u.userId} value={String(u.userId)}>{`${u.lastName ?? ''} ${u.firstName ?? ''}`.trim() || u.alias || ''}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button variant="contained" onClick={handleSave} sx={{ background: 'linear-gradient(135deg, #1A8CFF, #0F62CC)', fontFamily: "'Poppins', sans-serif", fontWeight: 600, textTransform: 'none', borderRadius: '8px', boxShadow: 'none' }}>
          Save Approvers
        </Button>
      </Box>
      <Snackbar open={snackbar.open} autoHideDuration={2000} onClose={() => setSnackbar(p => ({ ...p, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity={snackbar.severity} variant="filled" sx={{ fontFamily: "'Poppins', sans-serif", fontSize: '0.8rem' }}>{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
}
